export const linkToEpocusAdmin = () => "/epocus/admin";
export const linkToEpocusAdminProgram = (programId: string) =>
  `/epocus/admin/programs/${programId}`;
export const linkToEpocusAdminAddProgramUser = (programId: string) =>
  `/epocus/admin/programs/${programId}/users/new`;
